function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGameSettings = function SvgGameSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5-4.5C4.1-3.1 2.8-2 1.3-2-.3-2-1.6-3.1-1.9-4.5h-7.6c-.5 0-.8-.4-.8-.8 0-.5.3-.8.8-.8h7.6c.3-1.4 1.6-2.5 3.2-2.5 1.5 0 2.8 1.1 3.2 2.5h.9c.5 0 .9.4.9.8 0 .5-.4.8-.9.8zm-1.6-.8c0-1-.7-1.7-1.6-1.7s-1.7.7-1.7 1.7c0 .9.8 1.7 1.7 1.7.9-.1 1.6-.8 1.6-1.7M-5.4-2C-6.9-2-8.2-.9-8.6.5h-.9c-.5 0-.8.4-.8.8 0 .5.3.8.8.8h.9c.4 1.4 1.7 2.5 3.2 2.5 1.6 0 2.9-1.1 3.3-2.5h7.5c.5 0 .9-.4.9-.8 0-.5-.4-.8-.9-.8h-7.5C-2.5-.9-3.8-2-5.4-2m0 5C-6.3 3-7 2.3-7 1.3c0-.9.7-1.7 1.6-1.7 1 0 1.7.7 1.7 1.7S-4.4 3-5.4 3",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    transform: "translate(15 15)"
  }));
};
export default SvgGameSettings;